import React from "react";

const Item = ({label, value, onChange}) => (
  <label className="ros-item">
    {label}
    <select value={value} onChange={(e)=>onChange(Number(e.target.value))}>
      <option value={0}>No</option>
      <option value={1}>Yes</option>
    </select>
  </label>
);

export default function RosForm({ ros, onChange }) {
  const set = (k, v) => onChange({ ...ros, [k]: v });

  return (
    <div className="cn-card">
      <h3>Review of Systems (ROS)</h3>

      <h4>General / Constitutional</h4>
      <div className="row">
        <Item label="Chills" value={ros.chills} onChange={(v)=>set("chills", v)} />
        <Item label="Fever" value={ros.fever} onChange={(v)=>set("fever", v)} />
        <Item label="Lightheadedness" value={ros.lightheadedness} onChange={(v)=>set("lightheadedness", v)} />
        <Item label="Changes in appetite" value={ros.ChangesinAppetite} onChange={(v)=>set("ChangesinAppetite", v)} />
        <Item label="Fatigue" value={ros.Fatigue} onChange={(v)=>set("Fatigue", v)} />
        <Item label="Weight change" value={ros.WeightChange} onChange={(v)=>set("WeightChange", v)} />
      </div>

      <h4>Ophthalmologic</h4>
      <div className="row">
        <Item label="Vision changes" value={ros.VisionChanges} onChange={(v)=>set("VisionChanges", v)} />
        <Item label="Double vision" value={ros.Doublevision} onChange={(v)=>set("Doublevision", v)} />
        <Item label="Eye pain" value={ros.EyePain} onChange={(v)=>set("EyePain", v)} />
      </div>

      <h4>ENT / Nose / Throat</h4>
      <div className="row">
        <Item label="Decreased hearing" value={ros.Decreasedhearing} onChange={(v)=>set("Decreasedhearing", v)} />
        <Item label="Ringing in the ears" value={ros.Ringingintheears} onChange={(v)=>set("Ringingintheears", v)} />
        <Item label="Ear pain" value={ros.EarPain} onChange={(v)=>set("EarPain", v)} />
        <Item label="Nose bleed" value={ros.NoseBleed} onChange={(v)=>set("NoseBleed", v)} />
        <Item label="Nasal congestion" value={ros.NasalCongestion} onChange={(v)=>set("NasalCongestion", v)} />
        <Item label="Sinus pain" value={ros.sinuspain} onChange={(v)=>set("sinuspain", v)} />
        <Item label="Sore throat" value={ros.SoreThroat} onChange={(v)=>set("SoreThroat", v)} />
        <Item label="Difficulty swallowing" value={ros.Difficultyswallowing} onChange={(v)=>set("Difficultyswallowing", v)} />
      </div>

      {/* Endocrine, Respiratory, Cardiovascular, GI, GU, MSK, Neuro, Psych → ya preconfigurados en state; puedes ampliar igual que arriba */}
    </div>
  );
}
